// Pages
export const INDEX_PAGE_URL = '/';
export const HOME_PAGE_URL = '/home';
export const FAQ_PAGE_URL = '/faq';
export const ABOUT_PAGE_URL = '/about-me';
export const GALLERY_PAGE_URL = '/gallery';
export const LOCKTOBER_PAGE_URL = '/locktober';
export const SESSIONS_PAGE_URL = '/sessions';
export const FANSITES_PAGE_URL = '/fansites';
export const CLIPS_PAGE_URL = '/clips';
export const CONTACT_PAGE_URL = '/contact';
export const LINKS_PAGE_URL = '/links';
export const LOGIN_PAGE_URL = '/login';
export const POLICIES_PAGE_URL = '/user-agreements';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// Mailing_list routes
export const MAILING_LIST_PAGE_URL = '/mailing-list';
export const MAILING_LIST_CONFIRM_EMAIL_PAGE_URL = '/mailing-list/confirm-email';
export const MAILING_LIST_UNSUBSCRIBE_PAGE_URL = '/mailing-list/unsubscribe';
export const MAILING_LIST_ADMIN_PAGE_URL = '/admin/mailing-list-overview';